module.exports = __webpack_public_path__ + "static/media/TM.4919b102.svg";